import { render, staticRenderFns } from "./UserEditCredentials.vue?vue&type=template&id=50cb8d7d&"
import script from "./UserEditCredentials.vue?vue&type=script&lang=js&"
export * from "./UserEditCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50cb8d7d')) {
      api.createRecord('50cb8d7d', component.options)
    } else {
      api.reload('50cb8d7d', component.options)
    }
    module.hot.accept("./UserEditCredentials.vue?vue&type=template&id=50cb8d7d&", function () {
      api.rerender('50cb8d7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserEditCredentials.vue"
export default component.exports